// Utility to check if a JWT token is valid (not expired, not empty)

// Decode JWT payload safely
export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
}

// Checks if token is valid and issued within the last 10 minutes
export function isTokenValid(token) {
  if (!token || typeof token !== 'string') return false;
  const decoded = decodeJwtPayload(token);
  if (!decoded) return false;
  // Use iat (issued at) if available, else fallback to exp
  const now = Date.now();
  if (decoded.iat) {
    // iat is in seconds since epoch
    const ageMs = now - decoded.iat * 1000;
    if (ageMs > 10 * 60 * 1000) return false; // older than 10 minutes
  } else if (decoded.exp) {
    if (now > decoded.exp * 1000) return false;
  } else {
    return false;
  }
  return true;
}
